import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSimCard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSimCard2"><Path d="M17.5 2C18.8807 2 20 3.11929 20 4.5V19.5C20 20.8807 18.8807 22 17.5 22H6.5C5.11929 22 4 20.8807 4 19.5V7.74264C4 6.81438 4.36875 5.92415 5.02513 5.26777L7.26777 3.02513C7.92414 2.36875 8.81438 2 9.74264 2H12V7.5C12 7.77614 12.2239 8 12.5 8C12.7761 8 13 7.77614 13 7.5V2H16V7.5C16 7.77614 16.2239 8 16.5 8C16.7761 8 17 7.77614 17 7.5V2H17.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSimCard2;
